import localforage from 'localforage';
import { computed, ref } from 'vue';
import { defineStore } from 'pinia';

import type { GrantProgram } from '../utils/types';
import { calculationService } from '../utils/api/calculationService';

export const useGrantsStore = defineStore(
  'grants',
  () => {
    const data = ref<GrantProgram[] | null>(null);

    async function getGrantsFromLocalforage() {
      await localforage.getItem<GrantProgram[]>('grants');
    }

    async function fetch() {
      await getGrantsFromLocalforage();

      if (data.value) return;

      data.value = await calculationService.getGrants();
    }

    function invalidate() {
      data.value = null;

      fetch();
    }

    const grants = computed(() => data.value?.flatMap((grant) => grant.grants));

    const grantsLevels = computed(() => {
      const grantsData = grants.value || [];

      return grantsData.flatMap((grant) => grant.grant_levels);
    });

    const grantsLevelsOptions = computed(() => {
      const grantsLevelsData = grantsLevels.value || [];

      return grantsLevelsData.flatMap((grantLevel) => grantLevel.grant_level_options);
    });

    function getGrantById(id: number) {
      return grants.value?.find((grant) => grant.id === id);
    }

    function getGrantLevelOptionBtId(id: number) {
      return grantsLevelsOptions.value?.find((option) => option.id === id);
    }

    return {
      data,
      fetch,
      invalidate,
      grants,
      getGrantById,
      getGrantLevelOptionBtId,
    };
  },
  {
    // @ts-ignore
    persist: true,
  }
);
